<div class="checkbox">
  <label
    class="checkbox__label"
    [ngClass]="{
      'checkbox--readonly': isReadonly,
      'checkbox--checked': isChecked,
      'checkbox--disabled': isDisabled
    }"
  >
    <input
      type="checkbox"
      class="checkbox__input"
      checked="isChecked"
      [disabled]="isReadonly || isDisabled"
      (click)="onClick()"
      [attr.tabindex]="isReadonly || isDisabled ? -1 : null"
      [attr.aria-hidden]="isReadonly || isDisabled ? true : null"
    />
    <span class="icon icon-tick" aria-hidden="true"></span>
  </label>
  <span class="checkbox__text">
    <ng-content></ng-content>
  </span>
</div>
